/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Emoji_MissingInputs */



/**
* | output |
* | --- |
* | "[MISSING]" |
*
* @param {Error_Emoji_MissingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_emoji_missing = /** @type {((inputs?: Error_Emoji_MissingInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Emoji_MissingInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("[FEHLT]")
	if (locale === "fr") return /** @type {LocalizedString} */ ("[MANQUANTE]")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("[缺失]")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("[遺失]")
	if (locale === "ko") return /** @type {LocalizedString} */ ("[분실]")
	return /** @type {LocalizedString} */ ("[MISSING]")
});